import _objectWithoutProperties from "/home/runner/work/spa/spa/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["showEnergyCertificationModal"];
var __jsx = React.createElement;
import React from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'next-i18next';
import { Row, Text, CertificationsWrapper, Title, Wrapper, SeeEnergyCertificationLink } from './styles';
import { showModalAction } from '@spa/shared/store/actions/modal';
import { modalIds } from '@spa/offer/components/Modals/modal-displayer';
import EnergyCertificationLabel from '@spa/shared/components/EnergyCertificationLabel';
import { ENERGY_CERTIFICATION_LABEL_SIZES } from '@spa/shared/constants/energyCertificationLabelSizes';
var small = ENERGY_CERTIFICATION_LABEL_SIZES.small;
var EnergyCertification = function EnergyCertification(_ref) {
  var showEnergyCertificationModal = _ref.showEnergyCertificationModal,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var energyCertificateGrade = props.energyCertificateGrade,
    emissionsCertificateGrade = props.emissionsCertificateGrade;
  if (!energyCertificateGrade && !emissionsCertificateGrade) {
    return null;
  }
  return __jsx(Wrapper, null, __jsx(Title, null, t('Energy Certification')), __jsx(CertificationsWrapper, null, energyCertificateGrade && __jsx(EnergyCertificate, props), emissionsCertificateGrade && __jsx(EmissionsCertificate, props), __jsx(SeeEnergyCertificationLink, {
    onClick: function onClick() {
      return showEnergyCertificationModal(props);
    }
  }, t('See energy certification'))));
};
var EnergyCertificate = function EnergyCertificate(_ref2) {
  var energyCertificateGrade = _ref2.energyCertificateGrade,
    yearlyEnergyConsumption = _ref2.yearlyEnergyConsumption;
  var _useTranslation2 = useTranslation(),
    t = _useTranslation2.t;
  return __jsx(Row, null, __jsx(EnergyCertificationLabel, {
    grade: energyCertificateGrade,
    size: small
  }), yearlyEnergyConsumption ? __jsx(Text, null, t('Consumption'), ": ", t('{{yearlyEnergyConsumption}} kWh/m² year', {
    yearlyEnergyConsumption: yearlyEnergyConsumption
  })) : __jsx(Text, null, t('Consumption')));
};
var EmissionsCertificate = function EmissionsCertificate(_ref3) {
  var emissionsCertificateGrade = _ref3.emissionsCertificateGrade,
    yearlyEmissions = _ref3.yearlyEmissions;
  var _useTranslation3 = useTranslation(),
    t = _useTranslation3.t;
  return __jsx(Row, null, __jsx(EnergyCertificationLabel, {
    grade: emissionsCertificateGrade,
    size: small
  }), yearlyEmissions ? __jsx(Text, null, t('Emissions'), ": ", t('{{yearlyEmissions}} kg CO2/m² year', {
    yearlyEmissions: yearlyEmissions
  })) : __jsx(Text, null, t('Emissions')));
};
var mapStateToProps = function mapStateToProps(_ref4) {
  var _property$documentati;
  var property = _ref4.offer.offerAggregate.property_aggregate.property;
  var _ref5 = (property === null || property === void 0 ? void 0 : (_property$documentati = property.documentation) === null || _property$documentati === void 0 ? void 0 : _property$documentati.energy_certification) || {},
    energy_certificate = _ref5.energy_certificate,
    yearly_energy_consumption = _ref5.yearly_energy_consumption,
    emissions_certificate = _ref5.emissions_certificate,
    yearly_emissions = _ref5.yearly_emissions;
  return {
    energyCertificateGrade: energy_certificate,
    yearlyEnergyConsumption: yearly_energy_consumption,
    emissionsCertificateGrade: emissions_certificate,
    yearlyEmissions: yearly_emissions
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    showEnergyCertificationModal: function showEnergyCertificationModal(_ref6) {
      var energyCertificateGrade = _ref6.energyCertificateGrade,
        yearlyEnergyConsumption = _ref6.yearlyEnergyConsumption,
        emissionsCertificateGrade = _ref6.emissionsCertificateGrade,
        yearlyEmissions = _ref6.yearlyEmissions;
      return dispatch(showModalAction({
        modalId: modalIds.ENERGY_CERTIFICATION,
        energyCertificateGrade: energyCertificateGrade,
        yearlyEnergyConsumption: yearlyEnergyConsumption,
        emissionsCertificateGrade: emissionsCertificateGrade,
        yearlyEmissions: yearlyEmissions
      }));
    }
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(EnergyCertification);